import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { useTheme } from 'next-themes';

export const ErrorStatusCellRenderer = (props: ICellRendererParams) => {
  const hasError = props.value;
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  
  if (hasError) {
    return (
      <div className="flex items-center">
        <span className={`px-3 py-1.5 rounded-full text-sm font-medium inline-flex items-center gap-1.5 transition-all border ${
          isDarkMode ? 'bg-red-900/80 text-red-100 hover:bg-red-900 border-red-800' : 'bg-red-100 text-red-800 hover:bg-red-200 border-red-200'
        }`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 6 6 18"/>
            <path d="m6 6 12 12"/>
          </svg>
          Error
        </span>
      </div>
    );
  }
  
  return (
    <div className="flex items-center">
      <span className={`px-3 py-1.5 rounded-full text-sm font-medium inline-flex items-center gap-1.5 transition-all border ${
        isDarkMode ? 'bg-green-900/80 text-green-100 hover:bg-green-900 border-green-800' : 'bg-green-100 text-green-800 hover:bg-green-200 border-green-200'
      }`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6 9 17l-5-5"/>
        </svg>
        Valid
      </span>
    </div>
  );
}; 